module.exports = ".toast-container {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 99999; }\n"